<template>
  <div>
    <embed :src="signedUrl" type="application/pdf" :class="classes" :style="styles" v-if="urlReceiveFlag" />
    <embed :class="classes" type="application/pdf" :src="newSrcImage" :style="styles" v-else />
  </div>
</template>

<script>
import config from "@/config.js";
export default {
  props: ["src", "styles", "classes"],
  data: function () {
    return {
      signedUrl: "",
      urlReceiveFlag: false,
      newSrcImage: "",
    };
  },
  watch: {
    src: {
      handler(newValue) {
        if (newValue) {
          this.checkSrc();
        }
      },
    },
  },
  mounted() {
    // if (!this.src || this.src == "") return;
    this.checkSrc();
  },
  methods: {
    checkSrc() {
      if (this.src != "" && this.src.includes("amazonaws.com")) {
        this.urlReceiveFlag = true;
        this.loadImage();
      } else if (this.src.includes("blob")) {
        this.urlReceiveFlag = false;
        this.newSrcImage = this.src;
      } else {
        this.urlReceiveFlag = false;
        this.newSrcImage = this.src;
      }
    },
    loadImage() {
      this.$http
        .get(`${config.BASE_URL}api/v2/signed-resource?s3Url=${this.src}`)
        .then((response) => {
          this.signedUrl = response.data.signedUrl;
        })
        .catch(console.log);
      // this.signedUrl = response.signedUrl;
    },
  },
};
</script>

<style>
</style>





